var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FpPageBlock",
    {
      attrs: {
        fullscreen: "",
        "children-type": "column",
        children: { default: ["auto"], desktop: ["5fr", "6fr"] }
      }
    },
    [
      _c(
        "FpPageBlock",
        { style: { backgroundColor: "#E9EEFB" } },
        [
          _c(
            "FpFlex",
            {
              attrs: { "space-around": "", direction: _vm.FlexDirection.column }
            },
            [
              _c(
                "FpFlexItem",
                { attrs: { grow: "" } },
                [
                  _c(
                    "FpContainer",
                    { attrs: { border: "", elevated: "", grow: "" } },
                    [
                      _c(
                        "FpFlex",
                        {
                          attrs: {
                            "space-around": "",
                            direction: _vm.FlexDirection.column
                          }
                        },
                        [
                          _c("FpFlexItem", [_c("Header")], 1),
                          _vm._v(" "),
                          _c(
                            "FpFlexItem",
                            {
                              attrs: {
                                hide: [
                                  _vm.MediaSection.xLarge,
                                  _vm.MediaSection.large
                                ]
                              }
                            },
                            [
                              _c(
                                "FpImage",
                                {
                                  style: { width: "auto" },
                                  attrs: {
                                    title: _vm.$t(
                                      "common.images.houseAndBuilding.title"
                                    )
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.houseAndBuilding,
                                      alt: _vm.$t(
                                        "common.images.houseAndBuilding.alt"
                                      )
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "FpFlexItem",
                            { attrs: { grow: "" } },
                            [_vm._t("default")],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FpPageBlock", {
        style: {
          backgroundColor: "#E9EEFB",
          backgroundImage: "url(" + _vm.houseAndBuilding + ")",
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center right"
        },
        attrs: { "hide-on": "non-desktop" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }